import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap', {
  variants: {
    tone: {
      neutral: 'bg-surface-2 text-ink-2',
      primary: 'bg-primary-soft text-primary',
      gold: 'bg-gold text-ink', // "נקנה" — solid Jerusalem gold, dark text (6.6:1)
      goldSoft: 'bg-gold-soft text-gold-ink',
      success: 'bg-success-soft text-success-ink',
      danger: 'bg-danger-soft text-danger',
      warning: 'bg-warning-soft text-warning-ink',
    },
  },
  defaultVariants: { tone: 'neutral' },
});

export function Badge({ className, tone, ...props }: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
